import React from "react";
import { Tooltip, withStyles } from "@material-ui/core";
import moment from "moment";

const statusConfig = {
  FATURADO: { label: "Em aberto", color: "#f2a30b" },
  RECEBIDO: { label: "Recebido", color: "#007f79" },
  VENCIDO: { label: "Vencido", color: "#f50057" },
};

const formatCurrency = (value) =>
  (value ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const TituloParcelas = ({ classes, tituloParcelas }) => {
  if (!tituloParcelas?.length) return null;

  return (
    <div className={classes.container}>
      <span className={classes.title}>Parcelas</span>
      <div className={classes.header}>
        <span>Valor</span>
        <span>Vencimento</span>
        <span>Status</span>
      </div>
      <div className={classes.list}>
        {tituloParcelas.map((parcela) => {
          const { label, color } = statusConfig[parcela.status] || {
            label: parcela.status,
            color: "#868686",
          };
          return (
            <div key={parcela.id} className={classes.card}>
              <span className={classes.valor}>
                {formatCurrency(parcela.valor)}
              </span>
              <span className={classes.vencimento}>
                {parcela.dataVencimento
                  ? moment(parcela.dataVencimento).format("DD/MM/YYYY")
                  : "-"}
              </span>
              <Tooltip title={label} placement="top">
                <div
                  className={classes.statusBadge}
                  style={{
                    backgroundColor: `${color}18`,
                    border: `1px solid ${color}`,
                  }}
                >
                  <span
                    className={classes.statusDot}
                    style={{ backgroundColor: color }}
                  />
                  <span>{label}</span>
                </div>
              </Tooltip>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  title: {
    color: "#585858",
    fontWeight: "600",
    fontSize: "14px",
  },
  header: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    padding: "0 12px 4px",
    fontSize: "12px",
    fontWeight: "600",
    color: "#868686",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    maxHeight: "200px",
    overflowY: "auto",
    paddingRight: "4px",
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#BDBDBD",
      borderRadius: "4px",
    },
  },
  card: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    alignItems: "center",
    backgroundColor: "#F2F2F2",
    borderRadius: "8px",
    padding: "10px 12px",
  },
  valor: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#505050",
  },
  vencimento: {
    fontSize: "13px",
    color: "#505050",
  },
  statusBadge: {
    gap: "6px",
    width: "88px",
    display: "flex",
    padding: "4px 10px",
    fontSize: "12px",
    alignItems: "center",
    fontWeight: "500",
    borderRadius: "8px",
    justifyContent: "center",
    color: "#505050",
  },
  statusDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    flexShrink: 0,
  },
};

export default withStyles(styles)(TituloParcelas);
